/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'form-builder.QuestionType.ChoiceCascadingLabel': 'Kaskadlistruta',
  'form-builder.QuestionType.ChoiceDropdownLabel': 'Listruta',
  'form-builder.QuestionType.ChoiceDropdownMultipleLabel': 'Flervalslistruta',
  'form-builder.QuestionType.ChoiceMultipleLabel': 'Kryssrutor',
  'form-builder.QuestionType.ChoiceQuestionsGroupLabel': 'Valfält',
  'form-builder.QuestionType.ChoiceSingleLabel': 'Alternativknappar',
  'form-builder.QuestionType.CmdbObjectLabel': 'Tillgångar-objekt',
  'form-builder.QuestionType.DateLabel': 'Datum',
  'form-builder.QuestionType.DateQuestionsGroupLabel': 'Datumfält',
  'form-builder.QuestionType.DateTimeLabel': 'Datum och tid',
  'form-builder.QuestionType.NumberLabel': 'Nummer',
  'form-builder.QuestionType.NumericQuestionsGroupLabel': 'Numeriska fält',
  'form-builder.QuestionType.PlainTextParagraphLabel': 'None',
  'form-builder.QuestionType.RichTextParagraphLabel': 'Stycke',
  'form-builder.QuestionType.TextAttachmentLabel': 'Bilaga',
  'form-builder.QuestionType.TextEmailLabel': 'E-post',
  'form-builder.QuestionType.TextLongLabel': 'Lång text',
  'form-builder.QuestionType.TextParagraphLabel': 'Stycke',
  'form-builder.QuestionType.TextQuestionsGroupLabel': 'Textfält',
  'form-builder.QuestionType.TextShortLabel': 'Kort text',
  'form-builder.QuestionType.TextUrlLabel': 'URL',
  'form-builder.QuestionType.TimeLabel': 'Tid',
  'form-builder.QuestionType.UnsupportedLabel': 'Stöds inte',
  'form-builder.QuestionType.UserMultipleLabel': 'Flera användare',
  'form-builder.QuestionType.UserQuestionsGroupLabel': 'Användarfält',
  'form-builder.QuestionType.UserSingleLabel': 'En användare',
  'form-system.ChoiceQuestion.NewOptionPlaceholder': 'Nytt alternativ ...',
  'form-system.ChoiceQuestion.OtherPlaceholder': 'Annat ...',
  'form-system.ChoiceQuestion.SelectPlaceholder': 'Välj …',
  'form-system.DateQuestion.DatePlaceholder': 't.ex. {date}',
  'form-system.JiraField.ChoiceMultipleLabel': 'Flera val',
  'form-system.JiraField.ChoiceSingleLabel': 'Ett val',
  'form-system.JiraField.NoneLabel': 'Okänt',
  'form-system.JiraField.ParagraphLabel': 'Stycke',
  'form-system.JiraField.TextLabel': 'Text',
  'form-system.JiraField.UnsupportedLabel': 'Okänt',
  'form-system.TimeQuestion.TimePlaceholder': 't.ex. {time}',
  'form-system.UserPicker.UserPickerStartTyping': 'Börja skriva för att söka efter användare',
  'form-system.choice-dropdown.loading': 'Läser in …',
  'form-system.choice-dropdown.new-option': 'Nytt alternativ ...',
  'form-system.choice-dropdown.no-options': 'Inga alternativ',
  'form-system.choice-dropdown.select': 'Välj …',
  'form-system.date-time.date.label': 'Datum: {label}',
  'form-system.date-time.time.label': 'Tid: {label}',
  'form-system.general.Add': 'Lägg till',
  'form-system.general.All': 'Alla',
  'form-system.general.And': 'Och',
  'form-system.general.Back': 'Tillbaka',
  'form-system.general.Cancel': 'Avbryt',
  'form-system.general.Change': 'Ändra',
  'form-system.general.Close': 'Stäng',
  'form-system.general.Copy': 'Kopiera',
  'form-system.general.Create': 'Skapa',
  'form-system.general.CreateAnother': 'Skapa ett annat',
  'form-system.general.CreateForm': 'Skapa formulär',
  'form-system.general.Delete': 'Radera',
  'form-system.general.Download': 'Ladda ner',
  'form-system.general.Edit': 'Redigera',
  'form-system.general.Export': 'Exportera',
  'form-system.general.Json': 'JSON',
  'form-system.general.Loading': 'Läser in',
  'form-system.general.LoadingAvailableForms': 'Läser in tillgängliga formulär',
  'form-system.general.LoadingForm': 'Läser in formulär',
  'form-system.general.LoadingFormDetails': 'Läser in information om formulär',
  'form-system.general.Next': 'Nästa',
  'form-system.general.Of': 'av',
  'form-system.general.Prev': 'Föreg.',
  'form-system.general.Project': 'Projekt',
  'form-system.general.Reopen': 'Öppna på nytt',
  'form-system.general.Save': 'Spara',
  'form-system.general.Saved': 'Sparat',
  'form-system.general.Search': 'Sök',
  'form-system.general.Showing': 'Visar',
  'form-system.general.Submit': 'Skicka',
  'form-system.general.SubmitSave': 'Spara och skicka',
  'form-system.general.Templates': 'Mallar',
  'form-system.general.Upgrade': 'Uppgradera',
  'form-system.general.View': 'Vy',
  'form-system.general.Xlsx': 'XLSX',
  'form-system.headerBar.emptyFormName': 'Namnlöst formulär',
  'form-system.renderQuestion.read-only-reason-anonymous-message':
    'Logga in med ett giltigt konto för att komma åt detta fält.',
  'form-system.renderQuestion.read-only-reason-unlicensed-message':
    'Det här fältet är endast tillgängligt för användare med Jira-åtkomst.',
  'form-system.unknown-question-type': 'Vi kunde inte läsa in fälttypen <strong>{questionType}</strong> just nu.',
  'form-system.validationErrorMsg.Required': 'Fältet är obligatoriskt.',
  'form-system.validationErrorMsg.RequiredWithLabel': '{fieldLabel} krävs.',
  'form-system.validationErrorMsg.choice.BetweenChoices': 'Välj mellan {mns} och {mxs}.',
  'form-system.validationErrorMsg.choice.ExactChoices': 'Välj exakt {mns}.',
  'form-system.validationErrorMsg.choice.MaxChoices': 'Välj högst {mxs}.',
  'form-system.validationErrorMsg.choice.MinChoices': 'Välj minst {mns}.',
  'form-system.validationErrorMsg.choice.ReqChoice': "''{label}' måste väljas.",
  'form-system.validationErrorMsg.datetime.BetweenDate':
    'Datumet måste vara mellan {mnd,date,medium} och {mxd,date,medium}.',
  'form-system.validationErrorMsg.datetime.BetweenDateTime':
    'Datum och tid måste vara mellan {mnd,date,medium} kl. {mnt,time,short} och {mxd,date,medium} kl. {mxt,time,short}.',
  'form-system.validationErrorMsg.datetime.BetweenTime':
    'Tiden måste vara mellan {mnt,time,short} och {mxt,time,short}.',
  'form-system.validationErrorMsg.datetime.ExactDate': 'Datumet måste vara exakt {mnd,date,medium}.',
  'form-system.validationErrorMsg.datetime.ExactDateTime':
    'Datum och tid måste vara exakt {mnd,date,medium} kl. {mnt,time,short}.',
  'form-system.validationErrorMsg.datetime.ExactTime': 'Tiden måste vara exakt {mnt,time,short}.',
  'form-system.validationErrorMsg.datetime.InvalidTime': 'Tiden är ogiltig.',
  'form-system.validationErrorMsg.datetime.MaxDate': 'Datumet måste vara på eller före {mxd,date,medium}.',
  'form-system.validationErrorMsg.datetime.MaxDateTime':
    'Datum och tid måste vara på eller före {mxd,date,medium} kl. {mxt,time,short}.',
  'form-system.validationErrorMsg.datetime.MaxTime': 'Tiden måste vara vid eller före {mxt,time,short}.',
  'form-system.validationErrorMsg.datetime.MinDate': 'Datumet måste vara på eller efter {mnd,date,medium}.',
  'form-system.validationErrorMsg.datetime.MinDateTime':
    'Datum och tid måste vara på eller efter {mnd,date,medium} kl. {mnt,time,short}.',
  'form-system.validationErrorMsg.datetime.MinTime': 'Tiden måste vara på eller efter {mnt,time,short}.',
  'form-system.validationErrorMsg.datetime.RequiredDateTime': 'Fältet är obligatoriskt. Ange datum och tid.',
  'form-system.validationErrorMsg.datetime.RequiredDateTimeWithLabel': '{fieldLabel} krävs. Ange datum och tid.',
  'form-system.validationErrorMsg.number.BetweenNum': 'Måste vara mellan {mnn} och {mxn}.',
  'form-system.validationErrorMsg.number.ExactNum': 'Måste vara exakt {mnn}.',
  'form-system.validationErrorMsg.number.InvalidNum': 'Ange ett giltigt nummer.',
  'form-system.validationErrorMsg.number.MaxNum': 'Måste vara mindre än eller lika med {mxn}.',
  'form-system.validationErrorMsg.number.MinNum': 'Måste vara mer än eller lika med {mnn}.',
  'form-system.validationErrorMsg.number.WholeNum': 'Måste vara ett heltal.',
  'form-system.validationErrorMsg.text.BetweenChars':
    '{mxc, plural, one {Måste vara mellan {mnc} och {mxc,number} tecken.} other {Måste vara mellan {mnc} och {mxc,number} tecken.}}',
  'form-system.validationErrorMsg.text.BetweenWords':
    '{mxw, plural, one {Måste vara mellan {mnw} och {mxw,number} ord.} other {Måste vara mellan {mnw} och {mxw,number} ord.}}',
  'form-system.validationErrorMsg.text.ExactChars':
    '{mnc, plural, one {Måste vara exakt {mnc,number} tecken} other {Måste vara exakt {mnc,number} tecken}}',
  'form-system.validationErrorMsg.text.ExactWords':
    '{mnw, plural, one {Måste vara exakt {mnw,number} ord.} other {Måste vara exakt {mnw,number} ord.}}',
  'form-system.validationErrorMsg.text.InvalidEmail': 'Måste vara en e-postadress',
  'form-system.validationErrorMsg.text.InvalidUrl': 'Måste vara en giltig URL, t.ex. https://www.google.com/images',
  'form-system.validationErrorMsg.text.MaxChars':
    '{mxc, plural, one {Måste vara färre än {mxc,number} tecken.} other {Måste vara färre än {mxc,number} tecken.}}',
  'form-system.validationErrorMsg.text.MaxWords':
    '{mxw, plural, one {Måste vara färre än {mxw,number} ord.} other {Måste vara färre än {mxw,number} ord.}}',
  'form-system.validationErrorMsg.text.MinChars':
    '{mnc, plural, one {Måste vara fler än {mnc,number} tecken.} other {Måste vara fler än {mnc,number} tecken.}}',
  'form-system.validationErrorMsg.text.MinWords':
    '{mnw, plural, one {Måste vara fler än {mnw,number} ord.} other {Måste vara fler än {mnw,number} ord.}}',
  'form-system.validationErrorMsg.text.RegexCustomMsg': '{message}',
  'form-system.validationErrorMsg.text.RegexDefaultMsg': 'Svaret matchar inte det mönster som krävs.',
  'form-system.validationErrorMsg.text.RegexInvalidMsg':
    'Mönstret för reguljära uttryck för detta fält är ogiltigt. Svaret kan inte valideras.',
  'form-system.validationErrorMsg.userpicker.BetweenChoices':
    '{mxs, plural, one {Välj mellan {mns} och {mxs,number} användare.} other {Välj mellan {mns} och {mxs,number} användare.}}',
  'form-system.validationErrorMsg.userpicker.ExactChoices':
    '{mns, plural, one {Välj exakt {mns,number} användare.} other {Välj exakt {mns,number} användare.}}',
  'form-system.validationErrorMsg.userpicker.MaxChoices':
    '{mxs, plural, one {Välj högst {mxs,number} användare.} other {Välj högst {mxs,number} användare.}}',
  'form-system.validationErrorMsg.userpicker.MinChoices':
    '{mns, plural, one {Välj minst {mns,number} användare.} other {Välj minst {mns,number} användare.}}',
  'form-system.viewForm.HiddenSection': 'Dolt avsnitt – villkor gäller',
  'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-no-options':
    'Inga alternativ',
  'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-select': 'Välj …',
  'proforma-common-core.jira-common.models.jira-field.choice-cascading-label': 'Kaskadval',
  'proforma-form-builder.src.components.questiontypes.linked-field-icon.tooltip': 'Länkat till Jira-fältet {fieldName}',
  'proforma-form-builder.src.components.questiontypes.linked-field-icon.unknown-field': 'Länkat till Jira-fält',
  'ui-notices.apiError.msg.AddConnectionFailedMsg': 'Ett serverfel uppstod när dataanslutningen skulle läggas till.',
  'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg':
    'Ett serverfel uppstod när dataanslutningar skulle läsas in på mallformuläret.',
  'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg':
    'Ett serverfel uppstod när Jira-fält skulle läsas in på mallformuläret.',
  'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg':
    'Ett serverfel uppstod när referensen för mallformulärets inställningar skulle läsas in.',
  'ui-notices.apiError.msg.LoadTemplateFormFailedMsg': 'Uppdatera sidan för att försöka igen',
  'ui-notices.apiError.msg.MissingPermissionsMsg':
    'Du har inte behörighet att utföra den här åtgärden. Kontakta Jira-administratören.',
  'ui-notices.apiError.msg.SaveFormFailedMsg': 'Ett serverfel uppstod när formuläret skulle sparas.',
  'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg':
    'Inställningarna för det här formuläret har ändrats. Om du tror att detta är fel lämnar du en kommentar på förfrågan.',
  'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg':
    'Lös eventuella ogiltiga svar och kontrollera att alla obligatoriska fält är ifyllda.',
  'ui-notices.apiError.msg.SaveTemplateFormFailedMsg': 'Ett serverfel uppstod när mallformuläret skulle sparas.',
  'ui-notices.apiError.msg.SubmitFormFailedMsg': 'Ett serverfel uppstod när formuläret skulle skickas in.',
  'ui-notices.apiError.msg.UnauthorisedMsg': 'Uppdatera sidan och logga in i Jira igen.',
  'ui-notices.apiError.msg.UpdateConnectionFailedMsg': 'Ett serverfel uppstod när dataanslutningen skulle uppdateras.',
  'ui-notices.apiError.title.AddConnectionFailedTitle': 'Fel: Dataanslutningen kunde inte läggas till',
  'ui-notices.apiError.title.LoadDataConnectionsFailedTitle': 'Fel: Dataanslutningar kunde inte läsas in.',
  'ui-notices.apiError.title.LoadJiraFieldsFailedTitle': 'Fel: Jira-fält kunde inte läsas in',
  'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle':
    'Fel: Referensdata för formulärinställningar kunde inte läsas in.',
  'ui-notices.apiError.title.LoadTemplateFormFailedTitle': 'Vi kunde inte läsa in ditt formulär',
  'ui-notices.apiError.title.MissingPermissionsTitle': 'Fel: Användaren får inte utföra denna åtgärd',
  'ui-notices.apiError.title.SaveFormFailedTitle': 'Vi kunde inte spara dina ändringar',
  'ui-notices.apiError.title.SaveTemplateFormFailedTitle': 'Fel: Mallformuläret kunde inte sparas',
  'ui-notices.apiError.title.SubmitFormFailedTitle': 'Fel: Formuläret kunde inte skickas in',
  'ui-notices.apiError.title.UnauthorisedTitle': 'Fel: Obehörig användare',
  'ui-notices.apiError.title.UpdateConnectionFailedTitle': 'Fel: Dataanslutningen kunde inte uppdateras',
  'ui-notices.confirmText.Cancel': 'Avbryt',
  'ui-notices.confirmText.Change': 'Ändra',
  'ui-notices.confirmText.Close': 'Stäng',
  'ui-notices.confirmText.Confirm': 'Bekräfta',
  'ui-notices.confirmText.Delete': 'Radera',
  'ui-notices.confirmText.Discard': 'Kassera',
  'ui-notices.confirmText.MakeExternal': 'Gör externt',
  'ui-notices.confirmText.MakeInternal': 'Gör internt',
  'ui-notices.confirmText.Reopen': 'Öppna på nytt',
  'ui-notices.confirmText.Submit': 'Skicka',
  'ui-notices.confirmText.UpgradeNow': 'Uppgradera nu',
  'ui-notices.msg.CancelEditFormMsg':
    'De ändrade svaren i formuläret ”{formName}” kasseras om du väljer ”Bekräfta”. Är du säker på att du vill fortsätta?',
  'ui-notices.msg.ChangeFormInternalMsg':
    'Alla formulär som görs interna kommer endast att ses av agenter och döljas i portalen från kunder.',
  'ui-notices.msg.ChangeFormToExternalMsg':
    'Kunderna kommer att kunna se detta formulär i portalen och det kommer inte längre att bara vara internt.',
  'ui-notices.msg.DeleteFormMsg': 'Är du säker på att du vill radera formuläret ”{formName}”? Det här kan inte ångras.',
  'ui-notices.msg.ReopenFormMsg': 'Är du säker på att du vill öppna det skickade formuläret igen för att redigera det?',
  'ui-notices.msg.SubmitFormLockMsg':
    'Är du säker på att du vill skicka in formuläret? Du kan inte göra fler ändringar när det har skickats in.',
  'ui-notices.msg.SubmitFormMsg': 'Är du säker på att du vill skicka in formuläret?',
  'ui-notices.title.CancelEditFormTitle': 'Bekräfta kassering av ändringar',
  'ui-notices.title.ChangeFormAvailabilityTitle': 'Bekräfta ändring av formulärets tillgänglighet',
  'ui-notices.title.ChangeFormInternalHeader': 'Gör formuläret endast internt och dölj det för kunden',
  'ui-notices.title.ChangeFormToExternalHeader': 'Gör formuläret externt och visa det för kunden',
  'ui-notices.title.DeleteFormTitle': 'Bekräfta radering av formuläret',
  'ui-notices.title.ReopenFormTitle': 'Bekräfta att formuläret ska öppnas igen',
  'ui-notices.title.SubmitFormTitle': 'Bekräfta sändning av formuläret',
};
